<sl-modal-form [entityResource]="usersResource" [formGroup]="formGroup" title="{{ 'User.User' | translate }}">
    <sl-users-partial-form [formGroup]="formGroup" />
</sl-modal-form>
